export default "__VITE_ASSET__CoGjo_3$__"